import {useLocation, useNavigate} from "react-router-dom";
import {Button, NavBar, Space, Toast} from "antd-mobile";
import React, {useCallback, useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import {hubtelCancel, hubtelCheckStatus, hubtelGetDataById, hubtelReactivate} from "../../common/ApiAction";
import {TOASTDURATION} from "../../common/Utils";

const HubtelDetails = () => {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const location = useLocation();
    const [info, setInfo] = useState<any>({});

    const _getData = useCallback(() => {
        Toast.show({icon: 'loading', content: 'Login...', duration: 0})
        hubtelGetDataById(location.state).then((res: any) => {
            Toast.clear();
            if (res.executed) {
                setInfo(res.data);
            }   else {
                Toast.show({icon: 'fail', content: res.message, duration: 0})
            }
        }).catch(err => {
            Toast.clear();
            Toast.show({icon: 'fail', content: err.message, duration: 0})
        })
    }, [location.state])
    useEffect(() => {
        _getData()
    }, [_getData]);
    const back = () => {
        navigate(-1);
    };
    const _verifyAction = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        event.stopPropagation()
        navigate('/hubtel/verify', {state: {orderNo: info.orderNo, clientReferenceId: info.clientReferenceId}});
    }
    const _checkStatusAction = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        event.stopPropagation()
        Toast.show({icon: 'loading', content: 'Login...', duration: 0})
        hubtelCheckStatus(info.clientReferenceId).then((res: any) => {
            Toast.clear();
            if (res.executed) {
                setInfo(res.data);
            } else {
                Toast.show({icon: 'fail', content: res.message, duration: TOASTDURATION})
            }
        }).catch(err => {
            Toast.clear();
            Toast.show({icon: 'fail', content: err.message, duration: TOASTDURATION})
        })
    }
    const _cancelAction = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        event.stopPropagation()
        Toast.show({icon: 'loading', content: 'Login...', duration: 0})
        hubtelCancel(info.clientReferenceId).then((res: any) => {
            Toast.clear();
            if (res.executed) {
                Toast.show({icon:'success', content: 'Cancel Success!', duration: TOASTDURATION})
                back()
            } else {
                Toast.show({icon: 'fail', content: res.message, duration: TOASTDURATION})
            }
        }).catch(err => {
            Toast.clear();
            Toast.show({icon: 'fail', content: err.message, duration: TOASTDURATION})
        })
    }
    const _reactivateAction = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        event.stopPropagation()
        Toast.show({icon: 'loading', content: 'Login...', duration: 0})
        hubtelReactivate(info.clientReferenceId).then((res: any) => {
            Toast.clear();
            if (res.executed) {
                Toast.show({icon:'success', content: 'Reactivate Preapproval Success!', duration: TOASTDURATION})
            } else {
                Toast.show({icon: 'fail', content: res.message, duration: TOASTDURATION})
            }
        }).catch(err => {
            Toast.clear();
            Toast.show({icon: 'fail', content: err.message, duration: TOASTDURATION})
        })
    }
    const _renderItemUI = (title: string, data: any) => {
        return <div style={{padding: '13px 10px', display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center"}}>
            <span style={{fontSize: 15, color: '#000', fontWeight: "500"}}>{title}</span>
            <span style={{fontSize: 15, color: '#000', fontWeight: "bold"}}>{data ? data : '---'}</span>
        </div>
    }
    const _renderFunctionUI = () => {
        if (info.preapprovalStatus === 'Init') {
            return <div>
                <Space>
                    <Button color='primary' fill='outline'>Cancel</Button>
                </Space>
            </div>
        }
        if (info.preapprovalStatus === 'PENDING') {
            // 超出部分自动换行的样式
            return <div style={{display: 'flex', flexWrap: 'wrap', gap: '15px', justifyContent: 'flex-start'}}>
                <Button color='primary' fill='outline' onClick={(event) => {_verifyAction(event)}}>Verify</Button>
                <Button color='primary' fill='outline' onClick={(event) => {_checkStatusAction(event)}}>Check Status</Button>
                <Button color='primary' fill='outline' onClick={(event) => {_cancelAction(event)}}>Cancel</Button>
                <Button color='primary' fill='outline' onClick={(event) => {_reactivateAction(event)}}>Reactivate Preapproval</Button>
            </div>
        }
        if (info.preapprovalStatus === 'FAILED' || info.preapprovalStatus === 'EXPIRED' || info.preapprovalStatus === 'REJECTED') {
            return <div>
                <Space>
                    <Button color='primary' fill='outline'>Reactivate Preapproval</Button>
                </Space>
            </div>
        }
        return null;
    }
    return <div style={{display: "flex", flexDirection: "column", width: '100%',minHeight: '100vh', backgroundColor: '#F5F6FA', resize: "none", overflow: "auto"}}>
        <NavBar style={{backgroundColor: '#FFF'}} onBack={back}>Preapproval Details</NavBar>
        <div style={{marginTop: 30,backgroundColor: '#FFF', marginLeft: 15, marginRight: 15, border: 15}}>
            {_renderItemUI(t('common_ordere_no'), info.orderNo)}
            {_renderItemUI(t('create_order_user_name'), info.customerName)}
            {_renderItemUI(t('create_order_user_mobile'), info.customerMsisdn)}
            {_renderItemUI(t('hubtel_direct_debit_channel'), info.channel)}
            {_renderItemUI('ClientReferenceId', info.clientReferenceId)}
            {_renderItemUI('HubtelPreApprovalId', info.hubtelPreApprovalId)}
            {_renderItemUI('VerificationType', info.verificationType)}
            {_renderItemUI(t('common_application_time'), info.createTime)}
            {_renderItemUI(t('common_status'), info.preapprovalStatus)}
        </div>
        <div style={{marginTop: 30,backgroundColor: '#FFF', marginLeft: 15, marginRight: 15, border: 15, padding: '13px 10px'}}>
            {_renderFunctionUI()}
        </div>
    </div>;
}
export default HubtelDetails;

